import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonButton } from '@ionic/react'
import { productCenter, cartMobx } from 'restaurant'
import { switchMenuMobx } from '@mobxStore'
import { classNames } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import { Icon } from '@cps'
import './index.scss'

// props
interface IProps {
}

const SwitchMenu: FC<IProps> = ({ }) => {
  const history = useHistoryNew()
  const { earlyTime } = switchMenuMobx
  const canVisiblePage = ['/menu', '/checkout'].some(page => location.href.includes(page))

  // 处理切换菜单
  const handleSwitchMenu = function () {
    const pathname = history.location.pathname
    if (pathname.startsWith('/checkout')) {
      history.push('/menu')
    }
    productCenter.forward()
  }

  return (
    <>
      <div className={classNames('switch-menu', {
        hasCart: earlyTime > 0 && cartMobx.cartResult.totalCnt > 0,
        hide: earlyTime <= 0 || !canVisiblePage
      })}
      >
        <div className='tips'>
          <Icon name='time' />
          <p>
            <span>{i18n.t('menu.switchMenuTip1')}</span>
            <span className='time'>{earlyTime}</span>
            <span>{i18n.t('menu.switchMenuTip2')}</span>
          </p>
        </div>
        <IonButton color='primary' data-cypid='switchMenuConfirm' onClick={handleSwitchMenu}>{i18n.t('menu.switch')}</IonButton>
      </div>
    </>
  )
}

export default observer(SwitchMenu)
